import { C_ACCOUNT } from '_acaSrc/utility/constants';
import { MERGE_STATUSES } from './MergeAccountsConstants';
import ErrorHandler from './ErrorHandler';

export default class StatusHandler {
    static getErrorStatuses() {
        return C_ACCOUNT.FORM_MESSAGING.MERGE_ERROR_SETS.ERROR_STATUSES;
    }

    static getSameUserErrorStatuses() {
        return C_ACCOUNT.FORM_MESSAGING.MERGE_ERROR_SETS.SAME_USER_ERROR_STATUSES;
    }

    static createConsolidateFailureError() {
        return ErrorHandler.createErrorResponse(
            C_ACCOUNT.FORM_MESSAGING.MERGE_FAILURE_TYPE.CONSOLIDATE_FAILURE,
            C_ACCOUNT.FORM_MESSAGING.MERGE_ERROR_TITLE
        );
    }

    static createSameUserError() {
        return ErrorHandler.createErrorResponse(
            C_ACCOUNT.FORM_MESSAGING.MERGE_FAILURE_TYPE.CONSOLIDATE_SAME_USER,
            C_ACCOUNT.FORM_MESSAGING.MERGE_ERROR_TITLE
        );
    }

    static handleStatus(status, res, successHandler, errorHandler) {
        const errorStatuses = StatusHandler.getErrorStatuses();
        const sameUserErrorStatuses = StatusHandler.getSameUserErrorStatuses();

        if (errorStatuses.has(status)) {
            errorHandler(StatusHandler.createConsolidateFailureError());
        }
        else if (status === MERGE_STATUSES.SUCCESS) {
            successHandler(res);
        }
        else if (sameUserErrorStatuses.has(status)) {
            errorHandler(StatusHandler.createSameUserError());
        }
    }
}
